module.exports = __webpack_public_path__ + "img/全球覆盖.1079c8ce.svg";